import { gql } from 'apollo-angular';

export const ACCOUNT_BASIC_FRAGMENT = gql`
  fragment AccountBasicFragment on Account {
    id
    username
  }
`;
